import React from 'react';
export function IncludesSection() {
  return <section id="incluye" className="py-20 w-full" style={{
    backgroundColor: '#f8f8f8'
  }} aria-labelledby="incluye-title" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-61">
          <h2 id="incluye-title" className="font-heading text-4xl sm:text-5xl font-bold text-navy-deep mb-4" data-id="element-62">
            ¿Qué Incluye el Mega Pack?
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto" data-id="element-63">
            Todo lo que necesitás para tus clases, dividido por niveles y
            objetivos.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-64">
          {/* Card 1: Primaria */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden flex flex-col" data-id="element-65">
            <div className="h-48 overflow-hidden" data-id="element-66">
              <img src="https://cdn.magicpatterns.com/uploads/uMX7VjPKGpiYUTcQ8RyubG/ChatGPT_Image_28_feb_2026,_04_37_19_p.m..png" alt="Niños de primaria en clase de catequesis" className="w-full h-full object-cover object-center" data-id="element-67" />
            </div>
            <div className="p-6 flex flex-col flex-1" data-id="element-68">
              <span className="inline-block bg-navy-deep text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-3 w-fit" data-id="element-69">
                Nivel Primaria
              </span>
              <h3 className="font-heading text-2xl font-bold text-navy-deep mb-2" data-id="element-70">
                Catequesis Primaria
              </h3>
              <p className="text-gray-500 text-sm mb-5" data-id="element-71">
                Material completo para acompañar la fe de los más pequeños,
                grado por grado.
              </p>
              <ul className="space-y-2 flex-1" role="list" data-id="element-72">
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-73">
                  <span className="text-gold font-bold mt-0.5" data-id="element-74">✓</span>
                  <span data-id="element-75">
                    Planificaciones semanales por unidad (1° a 6° grado)
                  </span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-76">
                  <span className="text-gold font-bold mt-0.5" data-id="element-77">✓</span>
                  <span data-id="element-78">Actividades lúdicas y reflexivas</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-79">
                  <span className="text-gold font-bold mt-0.5" data-id="element-80">✓</span>
                  <span data-id="element-81">Preparación Primera Comunión</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-82">
                  <span className="text-gold font-bold mt-0.5" data-id="element-83">✓</span>
                  <span data-id="element-84">Evaluaciones adaptadas por edad</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Card 2: Secundaria (highlighted) */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col relative ring-2 ring-gold transform md:scale-105" data-id="element-85">
            {/* Most Popular Badge */}
            <div className="absolute top-4 right-4 z-10" data-id="element-86">
              <span className="bg-gold text-navy-deep text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full shadow" data-id="element-87">
                MÁS POPULAR
              </span>
            </div>
            <div className="h-48 overflow-hidden" data-id="element-88">
              <img src="https://cdn.magicpatterns.com/uploads/waHSqti1gEADGj3CmRNdHE/ChatGPT_Image_28_feb_2026,_04_43_39_p.m..png" alt="Adolescentes en clase de catequesis secundaria" className="w-full h-full object-cover object-center" data-id="element-89" />
            </div>
            <div className="p-6 flex flex-col flex-1" data-id="element-90">
              <span className="inline-block bg-gold text-navy-deep text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-3 w-fit" data-id="element-91">
                Nivel Secundaria
              </span>
              <h3 className="font-heading text-2xl font-bold text-navy-deep mb-2" data-id="element-92">
                Catequesis Secundaria
              </h3>
              <p className="text-gray-500 text-sm mb-5" data-id="element-93">
                Contenidos profundos y reflexivos para adolescentes, año por
                año.
              </p>
              <ul className="space-y-2 flex-1" role="list" data-id="element-94">
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-95">
                  <span className="text-gold font-bold mt-0.5" data-id="element-96">✓</span>
                  <span data-id="element-97">Planificaciones anuales completas (1° a 6° año)</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-98">
                  <span className="text-gold font-bold mt-0.5" data-id="element-99">✓</span>
                  <span data-id="element-100">DSI, ética, bioética, vocación</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-101">
                  <span className="text-gold font-bold mt-0.5" data-id="element-102">✓</span>
                  <span data-id="element-103">Preparación Confirmación</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-104">
                  <span className="text-gold font-bold mt-0.5" data-id="element-105">✓</span>
                  <span data-id="element-106">Proyectos solidarios y pastorales</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Card 3: Bonos */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden flex flex-col" data-id="element-107">
            <div className="h-48 overflow-hidden" data-id="element-108">
              <img src="https://cdn.magicpatterns.com/uploads/mfXLnQN6HYxG7SUhkHpA3w/ChatGPT_Image_28_feb_2026,_04_46_39_p.m..png" alt="Bonos exclusivos del Mega Pack Catequesis" className="w-full h-full object-cover object-center" data-id="element-109" />
            </div>
            <div className="p-6 flex flex-col flex-1" data-id="element-110">
              <span className="inline-block bg-navy-deep text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full mb-3 w-fit" data-id="element-111">
                Bonos Exclusivos
              </span>
              <h3 className="font-heading text-2xl font-bold text-navy-deep mb-2" data-id="element-112">
                Bonos Exclusivos
              </h3>
              <p className="text-gray-500 text-sm mb-5" data-id="element-113">
                Recursos extra para enriquecer tus clases y resolver cualquier
                situación.
              </p>
              <ul className="space-y-2 flex-1" role="list" data-id="element-114">
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-115">
                  <span className="text-gold font-bold mt-0.5" data-id="element-116">✓</span>
                  <span data-id="element-117">Ruta Anual: 36 semanas en 1 mapa visual</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-118">
                  <span className="text-gold font-bold mt-0.5" data-id="element-119">✓</span>
                  <span data-id="element-120">
                    Guía Comunión y Confirmación (Antes, Durante y Después)
                  </span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-121">
                  <span className="text-gold font-bold mt-0.5" data-id="element-122">✓</span>
                  <span data-id="element-123">Manual Catequesis sin Caos (Manejo de aula)</span>
                </li>
              </ul>

              {/* Bonus images preview */}
              <div className="mt-5 grid grid-cols-3 gap-2" data-id="element-124">
                <img src="https://cdn.magicpatterns.com/uploads/3pVTKHDcMeKdwsgEU9hg18/ChatGPT_Image_28_feb_2026,_10_57_00_a.m..png" alt="Ruta Anual Catequista" className="w-full h-16 object-cover rounded-lg shadow-sm" data-id="element-125" />
                <img src="https://cdn.magicpatterns.com/uploads/j6TJePJ2VdgbVtfqCC9vAv/ChatGPT_Image_28_feb_2026,_10_56_53_a.m..png" alt="Guía Comunión y Confirmación" className="w-full h-16 object-cover rounded-lg shadow-sm" data-id="element-126" />
                <img src="https://cdn.magicpatterns.com/uploads/e3V9vjpaBB8uFhRYBbEEjj/ChatGPT_Image_28_feb_2026,_10_56_49_a.m..png" alt="Manual Catequesis sin Caos" className="w-full h-16 object-cover rounded-lg shadow-sm" data-id="element-127" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}